export function getUserInitials(fullName: string | null | undefined, fallback = "?"): string {
	const names = fullName?.trim().split(/\s+/).filter(Boolean) ?? []
	const firstInitial = names[0]?.charAt(0) ?? ""
	const lastInitial = names.length > 1 ? names[names.length - 1]?.charAt(0) ?? "" : ""

	return `${firstInitial}${lastInitial}`.toUpperCase() || fallback
}
